<template>
  <div class="custom-steps">

    <!--未买入成功-->
    <div class="step-item">
      <div class="circle" :class="circleClass(0)">
        <template v-if="status === 0"><span></span></template>
        <template v-else><i class="el-icon-check"></i></template>
      </div>
    </div>

    <div class="step-line-wrap">
      <div class="step-line" :class="{'active-line': status === 1 || status > 1}"></div>
      <div class="step-label" v-if="status === 0">买入</div>
      <div class="step-label"  v-else-if="status === 1">正在买入</div>
      <div class="step-label"  v-else-if="status === 2 || status === 3 || status === 4">买入成功</div>
    </div>
    <div class="step-item">
      <div class="circle" :class="circleClass(1)">
        <template v-if="status < 2"><span></span></template>
        <template v-else><i class="el-icon-check"></i></template>
      </div>
    </div>
    <div class="step-line-wrap">
      <div class="step-line" :class="{'active-line': status === 3 || status > 3}"></div>
      <div class="step-label" v-if="status === 0 || status === 1 || status === 2">卖出</div>
      <div class="step-label"  v-else-if="status === 3">正在卖出</div>
      <div class="step-label"  v-else-if="status === 4">卖出成功</div>
    </div>
    <div class="step-item">
      <div class="circle" :class="circleClass(2)">
        <span v-if="status < 4"></span>
        <i v-else class="el-icon-check"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepBar',
  props: {
    status: {
      type: Number,
      required: true
    }
  },
  methods: {
    circleClass(index) {
      // 0:等待中 1:正在买入 2:买入成功 3:正在卖出 4:卖出成功
      if (index === 0) {
        if (this.status === 0) return 'wait';
        return 'buy-success';
      }
      if (index === 1) {
        if (this.status < 2) return 'wait';
        if (this.status >= 2) return 'buy-success';
        // if (this.status === 3) return 'selling';
        // if (this.status === 4) return 'sell-success';
      }
      if (index === 2) {
        if (this.status < 4) return 'wait';
        return 'buy-success';
      }
      return '';
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 32px auto 16px auto;
  width: 90%;
}
.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  position: relative;
  .circle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #E5E5E5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #E5E5E5;
    background-color: #f3f3f3;
    box-shadow: 0 0 0 8px rgba(84, 188, 103, 0.2);
    position: relative;
    z-index: 1;
    transition: all 0.3s;
  }
  .circle.wait {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    box-shadow:none;
    border: none;
  }
  .circle.buy-success {
    border: 2px solid #54BC67;
    background-color: #54BC67;
    color: #fff;
    i{
      z-index: 5;
      font-size: 12px;
    }
  }
  .ddz{
    display: block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    border: 6px solid #54BC67;
  }
}

//.circle.selling {
//  border: 2px solid #FF9900;
//  color: #FF9900;
//  background: #FFF7E6;
//}
//.circle.sell-success {
//  background: #54BC67;
//  border: 2px solid #54BC67;
//  color: #fff;
//}
.icon-check {
  font-size: 20px;
  font-weight: bold;
}
.step-line-wrap {
  position: relative;
  width: 100%;
  .step-line {
    width: 100%;
    height: 4px;
    border-radius: 2px;
    //margin-bottom: 4px;
    background: #f3f3f3;
    transition: background 0.3s;
  }
  .step-line.active-line {
    background: rgba(84, 188, 103, 0.2);
  }
  .step-label {
    font-size: 14px;
    color: #000;
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 10px;
  }
}

</style>